'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';
import { DeprecatedDropdown, DeprecatedDropdownButton } from '../Dropdown';
import { NavFlyout } from '../NavFlyout/NavFlyout';
import { excludeComponentProps } from '../utils/excludeComponentProps';
import { navCssClassNames } from './navCssClassNames';
import { navItemButtonCss } from './navItemButtonCss';
import clsx from 'clsx';
const StyledDropdownButton = styled(DeprecatedDropdownButton, excludeComponentProps('subNavigationItems', 'orientation', 'size', 'level', 'label', 'hasDivider'))(navItemButtonCss);
export const NavItemDropdown = forwardRef(({ items, hasDivider, className, ...props }, ref) => (_jsxs(DeprecatedDropdown, { children: [_jsx(StyledDropdownButton, { ...props, className: clsx(navCssClassNames.itemDropdownButton, className), endIcon: _jsx(KeyboardArrowDown, {}), orientation: 'top', ref: ref }), _jsx(NavFlyout, { className: navCssClassNames.itemDropdownMenu, hasDivider: hasDivider, items: items })] })));
NavItemDropdown.displayName = 'NavItemDropdown';
